import JitsiVideoConference from './JitsiVideoConference';

export default JitsiVideoConference;